import '../../core/components/app-root/AppRoot.css';
import './CodeHighlight.css';
import './CodeSnippet.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var copyButtonContainer = _7a468({defaultClassName:'_17pa72a6-3-12-1',variantClassNames:{size:{'default':'_17pa72a7-3-12-1',condensed:'_17pa72a8-3-12-1'}},defaultVariants:{size:'default'},compoundVariants:[]});
export var wrapper = '_17pa72a1-3-12-1';
export var wrapperFullHeight = '_17pa72a2-3-12-1';
export var wrapperGutter = _7a468({defaultClassName:'_17pa72a3-3-12-1',variantClassNames:{size:{'default':'_17pa72a4-3-12-1',condensed:'_17pa72a5-3-12-1'}},defaultVariants:{size:'default'},compoundVariants:[]});